import { screen } from '@tumelo/designsystem'
import styled from 'styled-components'
import { largeUpStyle, LargeUpStyleProps } from '@/styles/outerContainerStyles'

export const OuterContainerLayout = styled.div<LargeUpStyleProps>`
  height: 100%;
  width: 100%;

  padding: 1.6rem;

  @media ${screen.smallUp} {
    padding: 2.4rem;
  }

  @media ${screen.mediumUp} {
    padding: 3.2rem;
  }

  ${(props) => largeUpStyle(props)}
`
